import * as Yup from 'yup';

import { phoneNumberValidator } from '@zen/utils/validation';

import { termsAndConditionValidation } from '../components/forms/FormTermsAndConditionsCheckbox';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  name: Yup.string().nullable().required('Please enter your name.'),
  phoneNumber: phoneNumberValidator,
  terms: termsAndConditionValidation
});
